import './auto-complete-text-field2-modal.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { BModal } from 'bootstrap-vue';
import { faCheck } from '@fortawesome/free-solid-svg-icons'

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { FIELD_VALUE_UPDATED } from '../../events';  

@Component({
    props: {
        availableValues: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        title: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        primaryColor: {
            type: Boolean,
            default: false,
        },
        xxl: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./auto-complete-text-field2-modal.html')
})
export class AutoCompleteTextField2Modal extends ReactiveVue {
    private availableValues: String[]
    private value: String
    private placeholder: String
    private title: String
    private readonly: Boolean
    private primaryColor: Boolean
    private xxl: Boolean

    public checkIcon = faCheck

    public $refs: {
        modal: BModal,
        modalInput,
    }

    private get valueCopy(): String {
        return this.value
    }

    private set valueCopy(newValue: String) {
        this.$emit(FIELD_VALUE_UPDATED, newValue)
    }

    private get filteredSuggestions() {
        return this.availableValues.filter(value => {
            return value.includes(this.valueCopy as string) && value != this.valueCopy
        })
    }

    private onSuggestionClicked(value: string) {
        this.valueCopy = value
        setTimeout(
            () => {
                this.$refs.modal.hide()
            },
            200
        )
    }

    public closeModal() {
        this.$refs.modal.hide()
    }

    public openModal() {
        this.$refs.modal.show()
    }
}